module.exports = __webpack_public_path__ + "13be7a9b336a2d6deb0d32d36f8160c2.svg";